/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedAccessDeniedRouteImport } from './routes/_authenticated/access-denied'
import { Route as AuthenticatedUserMgtSupervisorsRouteImport } from './routes/_authenticated/user-mgt/supervisors'
import { Route as AuthenticatedUserMgtStaffMembersRouteImport } from './routes/_authenticated/user-mgt/staff-members'
import { Route as AuthenticatedUserMgtDirectoratesRouteImport } from './routes/_authenticated/user-mgt/directorates'
import { Route as AuthenticatedUserMgtDepartmentsRouteImport } from './routes/_authenticated/user-mgt/departments'
import { Route as AuthenticatedLeaveCalendarRouteImport } from './routes/_authenticated/leave/calendar'
import { Route as AuthenticatedLeaveApprovalsRouteImport } from './routes/_authenticated/leave/approvals'
import { Route as AuthenticatedLeaveApplicationsRouteImport } from './routes/_authenticated/leave/applications'
import { Route as AuthenticatedLeaveMgtReportsRouteImport } from './routes/_authenticated/leave-mgt/reports'
import { Route as AuthenticatedLeaveMgtLeaveRequestsRouteImport } from './routes/_authenticated/leave-mgt/leave-requests'
import { Route as AuthenticatedLeaveMgtDelegationsRouteImport } from './routes/_authenticated/leave-mgt/delegations'
import { Route as AuthenticatedLeaveConfigLeaveTypesRouteImport } from './routes/_authenticated/leave/config/leave-types'
import { Route as AuthenticatedLeaveConfigHolidaysRouteImport } from './routes/_authenticated/leave/config/holidays'
import { Route as AuthenticatedLeaveConfigBalancesRouteImport } from './routes/_authenticated/leave/config/balances'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAccessDeniedRoute =
  AuthenticatedAccessDeniedRouteImport.update({
    id: '/access-denied',
    path: '/access-denied',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUserMgtSupervisorsRoute =
  AuthenticatedUserMgtSupervisorsRouteImport.update({
    id: '/user-mgt/supervisors',
    path: '/user-mgt/supervisors',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUserMgtStaffMembersRoute =
  AuthenticatedUserMgtStaffMembersRouteImport.update({
    id: '/user-mgt/staff-members',
    path: '/user-mgt/staff-members',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUserMgtDirectoratesRoute =
  AuthenticatedUserMgtDirectoratesRouteImport.update({
    id: '/user-mgt/directorates',
    path: '/user-mgt/directorates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUserMgtDepartmentsRoute =
  AuthenticatedUserMgtDepartmentsRouteImport.update({
    id: '/user-mgt/departments',
    path: '/user-mgt/departments',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveCalendarRoute =
  AuthenticatedLeaveCalendarRouteImport.update({
    id: '/leave/calendar',
    path: '/leave/calendar',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveApprovalsRoute =
  AuthenticatedLeaveApprovalsRouteImport.update({
    id: '/leave/approvals',
    path: '/leave/approvals',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveApplicationsRoute =
  AuthenticatedLeaveApplicationsRouteImport.update({
    id: '/leave/applications',
    path: '/leave/applications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveMgtReportsRoute =
  AuthenticatedLeaveMgtReportsRouteImport.update({
    id: '/leave-mgt/reports',
    path: '/leave-mgt/reports',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveMgtLeaveRequestsRoute =
  AuthenticatedLeaveMgtLeaveRequestsRouteImport.update({
    id: '/leave-mgt/leave-requests',
    path: '/leave-mgt/leave-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveMgtDelegationsRoute =
  AuthenticatedLeaveMgtDelegationsRouteImport.update({
    id: '/leave-mgt/delegations',
    path: '/leave-mgt/delegations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveConfigLeaveTypesRoute =
  AuthenticatedLeaveConfigLeaveTypesRouteImport.update({
    id: '/leave/config/leave-types',
    path: '/leave/config/leave-types',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveConfigHolidaysRoute =
  AuthenticatedLeaveConfigHolidaysRouteImport.update({
    id: '/leave/config/holidays',
    path: '/leave/config/holidays',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaveConfigBalancesRoute =
  AuthenticatedLeaveConfigBalancesRouteImport.update({
    id: '/leave/config/balances',
    path: '/leave/config/balances',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/access-denied': typeof AuthenticatedAccessDeniedRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/leave-mgt/delegations': typeof AuthenticatedLeaveMgtDelegationsRoute
  '/leave-mgt/leave-requests': typeof AuthenticatedLeaveMgtLeaveRequestsRoute
  '/leave-mgt/reports': typeof AuthenticatedLeaveMgtReportsRoute
  '/leave/applications': typeof AuthenticatedLeaveApplicationsRoute
  '/leave/approvals': typeof AuthenticatedLeaveApprovalsRoute
  '/leave/calendar': typeof AuthenticatedLeaveCalendarRoute
  '/user-mgt/departments': typeof AuthenticatedUserMgtDepartmentsRoute
  '/user-mgt/directorates': typeof AuthenticatedUserMgtDirectoratesRoute
  '/user-mgt/staff-members': typeof AuthenticatedUserMgtStaffMembersRoute
  '/user-mgt/supervisors': typeof AuthenticatedUserMgtSupervisorsRoute
  '/leave/config/balances': typeof AuthenticatedLeaveConfigBalancesRoute
  '/leave/config/holidays': typeof AuthenticatedLeaveConfigHolidaysRoute
  '/leave/config/leave-types': typeof AuthenticatedLeaveConfigLeaveTypesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/access-denied': typeof AuthenticatedAccessDeniedRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/leave-mgt/delegations': typeof AuthenticatedLeaveMgtDelegationsRoute
  '/leave-mgt/leave-requests': typeof AuthenticatedLeaveMgtLeaveRequestsRoute
  '/leave-mgt/reports': typeof AuthenticatedLeaveMgtReportsRoute
  '/leave/applications': typeof AuthenticatedLeaveApplicationsRoute
  '/leave/approvals': typeof AuthenticatedLeaveApprovalsRoute
  '/leave/calendar': typeof AuthenticatedLeaveCalendarRoute
  '/user-mgt/departments': typeof AuthenticatedUserMgtDepartmentsRoute
  '/user-mgt/directorates': typeof AuthenticatedUserMgtDirectoratesRoute
  '/user-mgt/staff-members': typeof AuthenticatedUserMgtStaffMembersRoute
  '/user-mgt/supervisors': typeof AuthenticatedUserMgtSupervisorsRoute
  '/leave/config/balances': typeof AuthenticatedLeaveConfigBalancesRoute
  '/leave/config/holidays': typeof AuthenticatedLeaveConfigHolidaysRoute
  '/leave/config/leave-types': typeof AuthenticatedLeaveConfigLeaveTypesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_authenticated/access-denied': typeof AuthenticatedAccessDeniedRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/leave-mgt/delegations': typeof AuthenticatedLeaveMgtDelegationsRoute
  '/_authenticated/leave-mgt/leave-requests': typeof AuthenticatedLeaveMgtLeaveRequestsRoute
  '/_authenticated/leave-mgt/reports': typeof AuthenticatedLeaveMgtReportsRoute
  '/_authenticated/leave/applications': typeof AuthenticatedLeaveApplicationsRoute
  '/_authenticated/leave/approvals': typeof AuthenticatedLeaveApprovalsRoute
  '/_authenticated/leave/calendar': typeof AuthenticatedLeaveCalendarRoute
  '/_authenticated/user-mgt/departments': typeof AuthenticatedUserMgtDepartmentsRoute
  '/_authenticated/user-mgt/directorates': typeof AuthenticatedUserMgtDirectoratesRoute
  '/_authenticated/user-mgt/staff-members': typeof AuthenticatedUserMgtStaffMembersRoute
  '/_authenticated/user-mgt/supervisors': typeof AuthenticatedUserMgtSupervisorsRoute
  '/_authenticated/leave/config/balances': typeof AuthenticatedLeaveConfigBalancesRoute
  '/_authenticated/leave/config/holidays': typeof AuthenticatedLeaveConfigHolidaysRoute
  '/_authenticated/leave/config/leave-types': typeof AuthenticatedLeaveConfigLeaveTypesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/access-denied'
    | '/profile'
    | '/leave-mgt/delegations'
    | '/leave-mgt/leave-requests'
    | '/leave-mgt/reports'
    | '/leave/applications'
    | '/leave/approvals'
    | '/leave/calendar'
    | '/user-mgt/departments'
    | '/user-mgt/directorates'
    | '/user-mgt/staff-members'
    | '/user-mgt/supervisors'
    | '/leave/config/balances'
    | '/leave/config/holidays'
    | '/leave/config/leave-types'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/access-denied'
    | '/profile'
    | '/leave-mgt/delegations'
    | '/leave-mgt/leave-requests'
    | '/leave-mgt/reports'
    | '/leave/applications'
    | '/leave/approvals'
    | '/leave/calendar'
    | '/user-mgt/departments'
    | '/user-mgt/directorates'
    | '/user-mgt/staff-members'
    | '/user-mgt/supervisors'
    | '/leave/config/balances'
    | '/leave/config/holidays'
    | '/leave/config/leave-types'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/_authenticated/access-denied'
    | '/_authenticated/profile'
    | '/_authenticated/leave-mgt/delegations'
    | '/_authenticated/leave-mgt/leave-requests'
    | '/_authenticated/leave-mgt/reports'
    | '/_authenticated/leave/applications'
    | '/_authenticated/leave/approvals'
    | '/_authenticated/leave/calendar'
    | '/_authenticated/user-mgt/departments'
    | '/_authenticated/user-mgt/directorates'
    | '/_authenticated/user-mgt/staff-members'
    | '/_authenticated/user-mgt/supervisors'
    | '/_authenticated/leave/config/balances'
    | '/_authenticated/leave/config/holidays'
    | '/_authenticated/leave/config/leave-types'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  NotFoundRoute: typeof NotFoundRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/access-denied': {
      id: '/_authenticated/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AuthenticatedAccessDeniedRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/user-mgt/supervisors': {
      id: '/_authenticated/user-mgt/supervisors'
      path: '/user-mgt/supervisors'
      fullPath: '/user-mgt/supervisors'
      preLoaderRoute: typeof AuthenticatedUserMgtSupervisorsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/user-mgt/staff-members': {
      id: '/_authenticated/user-mgt/staff-members'
      path: '/user-mgt/staff-members'
      fullPath: '/user-mgt/staff-members'
      preLoaderRoute: typeof AuthenticatedUserMgtStaffMembersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/user-mgt/directorates': {
      id: '/_authenticated/user-mgt/directorates'
      path: '/user-mgt/directorates'
      fullPath: '/user-mgt/directorates'
      preLoaderRoute: typeof AuthenticatedUserMgtDirectoratesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/user-mgt/departments': {
      id: '/_authenticated/user-mgt/departments'
      path: '/user-mgt/departments'
      fullPath: '/user-mgt/departments'
      preLoaderRoute: typeof AuthenticatedUserMgtDepartmentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave/calendar': {
      id: '/_authenticated/leave/calendar'
      path: '/leave/calendar'
      fullPath: '/leave/calendar'
      preLoaderRoute: typeof AuthenticatedLeaveCalendarRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave/approvals': {
      id: '/_authenticated/leave/approvals'
      path: '/leave/approvals'
      fullPath: '/leave/approvals'
      preLoaderRoute: typeof AuthenticatedLeaveApprovalsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave/applications': {
      id: '/_authenticated/leave/applications'
      path: '/leave/applications'
      fullPath: '/leave/applications'
      preLoaderRoute: typeof AuthenticatedLeaveApplicationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave-mgt/reports': {
      id: '/_authenticated/leave-mgt/reports'
      path: '/leave-mgt/reports'
      fullPath: '/leave-mgt/reports'
      preLoaderRoute: typeof AuthenticatedLeaveMgtReportsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave-mgt/leave-requests': {
      id: '/_authenticated/leave-mgt/leave-requests'
      path: '/leave-mgt/leave-requests'
      fullPath: '/leave-mgt/leave-requests'
      preLoaderRoute: typeof AuthenticatedLeaveMgtLeaveRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave-mgt/delegations': {
      id: '/_authenticated/leave-mgt/delegations'
      path: '/leave-mgt/delegations'
      fullPath: '/leave-mgt/delegations'
      preLoaderRoute: typeof AuthenticatedLeaveMgtDelegationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave/config/leave-types': {
      id: '/_authenticated/leave/config/leave-types'
      path: '/leave/config/leave-types'
      fullPath: '/leave/config/leave-types'
      preLoaderRoute: typeof AuthenticatedLeaveConfigLeaveTypesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave/config/holidays': {
      id: '/_authenticated/leave/config/holidays'
      path: '/leave/config/holidays'
      fullPath: '/leave/config/holidays'
      preLoaderRoute: typeof AuthenticatedLeaveConfigHolidaysRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leave/config/balances': {
      id: '/_authenticated/leave/config/balances'
      path: '/leave/config/balances'
      fullPath: '/leave/config/balances'
      preLoaderRoute: typeof AuthenticatedLeaveConfigBalancesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAccessDeniedRoute: typeof AuthenticatedAccessDeniedRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedLeaveMgtDelegationsRoute: typeof AuthenticatedLeaveMgtDelegationsRoute
  AuthenticatedLeaveMgtLeaveRequestsRoute: typeof AuthenticatedLeaveMgtLeaveRequestsRoute
  AuthenticatedLeaveMgtReportsRoute: typeof AuthenticatedLeaveMgtReportsRoute
  AuthenticatedLeaveApplicationsRoute: typeof AuthenticatedLeaveApplicationsRoute
  AuthenticatedLeaveApprovalsRoute: typeof AuthenticatedLeaveApprovalsRoute
  AuthenticatedLeaveCalendarRoute: typeof AuthenticatedLeaveCalendarRoute
  AuthenticatedUserMgtDepartmentsRoute: typeof AuthenticatedUserMgtDepartmentsRoute
  AuthenticatedUserMgtDirectoratesRoute: typeof AuthenticatedUserMgtDirectoratesRoute
  AuthenticatedUserMgtStaffMembersRoute: typeof AuthenticatedUserMgtStaffMembersRoute
  AuthenticatedUserMgtSupervisorsRoute: typeof AuthenticatedUserMgtSupervisorsRoute
  AuthenticatedLeaveConfigBalancesRoute: typeof AuthenticatedLeaveConfigBalancesRoute
  AuthenticatedLeaveConfigHolidaysRoute: typeof AuthenticatedLeaveConfigHolidaysRoute
  AuthenticatedLeaveConfigLeaveTypesRoute: typeof AuthenticatedLeaveConfigLeaveTypesRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAccessDeniedRoute: AuthenticatedAccessDeniedRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedLeaveMgtDelegationsRoute: AuthenticatedLeaveMgtDelegationsRoute,
  AuthenticatedLeaveMgtLeaveRequestsRoute:
    AuthenticatedLeaveMgtLeaveRequestsRoute,
  AuthenticatedLeaveMgtReportsRoute: AuthenticatedLeaveMgtReportsRoute,
  AuthenticatedLeaveApplicationsRoute: AuthenticatedLeaveApplicationsRoute,
  AuthenticatedLeaveApprovalsRoute: AuthenticatedLeaveApprovalsRoute,
  AuthenticatedLeaveCalendarRoute: AuthenticatedLeaveCalendarRoute,
  AuthenticatedUserMgtDepartmentsRoute: AuthenticatedUserMgtDepartmentsRoute,
  AuthenticatedUserMgtDirectoratesRoute: AuthenticatedUserMgtDirectoratesRoute,
  AuthenticatedUserMgtStaffMembersRoute: AuthenticatedUserMgtStaffMembersRoute,
  AuthenticatedUserMgtSupervisorsRoute: AuthenticatedUserMgtSupervisorsRoute,
  AuthenticatedLeaveConfigBalancesRoute: AuthenticatedLeaveConfigBalancesRoute,
  AuthenticatedLeaveConfigHolidaysRoute: AuthenticatedLeaveConfigHolidaysRoute,
  AuthenticatedLeaveConfigLeaveTypesRoute:
    AuthenticatedLeaveConfigLeaveTypesRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  NotFoundRoute: NotFoundRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
